import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';

export const CardContainer = styled.div`
    display: ${({ display }) => display || 'flex'};
    flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
    margin: ${({ margin }) => margin ? margin : '10px 10px'};
   // width: ${({ width }) => width || 'calc(100% - 20px)'};
   width : ${({ width }) => width ? width : '100%'};
     min-width: ${({ maxWidth }) => maxWidth && '320px'}; 
    max-width: ${({ minWidth }) => minWidth && '320px'}; 
    height: ${({ height }) => height || 'auto'};
    justify-content: ${({ justifyContent }) => justifyContent ? justifyContent :'stretch'};
    //justify-content: ${({ justifyContent }) => justifyContent || 'space-evenly'};
    position: relative;
    box-shadow: ${({ isHideBoxShadow, boxShadow }) =>
        isHideBoxShadow ? 'none' : boxShadow || '0px 0px 6px #00000029'};
    background: ${({ background, backgroundColor }) =>
        background || backgroundColor || '#ffffff 0% 0% no-repeat padding-box'};
    border: ${({ border }) =>
        typeof border === 'string'
            ? border
            : border && border.border
            ? border.border
            : 'none'};
          border-left: ${({ borderLeft }) => borderLeft ? 'none' :borderLeft };
    border-radius: ${({ borderRadius }) => borderRadius || '6px'};
    padding: ${({ padding }) => padding || '0px'};
    cursor: ${({ cursor }) => cursor || 'pointer'};
    box-sizing: border-box;
    ${({ selected }) =>
        selected &&
        css`
            outline: 2px solid #1010eb;
        `}
    ${({ shippingMinHeight }) =>
        shippingMinHeight &&
        css`
            min-height: ${shippingMinHeight};
        `}
    ${({ weekView }) =>
        weekView &&
        css`
            margin: 5px 0;
            width: 148.87px;
            min-width: 148.87px;
            max-width: 148.87px;
        `}

    ${media.mediumDevice`
        /* min-width: 350px;
        max-width: 364px; */
        ${({ weekView }) =>
            weekView &&
            `margin: 5px 0;  width:148.87px; min-width: 148.87px;
        max-width: 148.87px; background: transparent;`}
    `}

    @media only screen and (max-width: 830px) {
       // margin: 10px 15px;
        ${({ weekView }) =>
            weekView &&
            `margin: 5px 0;  width:148.87px; min-width:148.87px;
        max-width:148.87px; `}
    }

    ${media.smalDevice`
        /* min-width:310px;
        max-width:320px; */
          max-width: ${({ mobileMaxWidth }) =>
            mobileMaxWidth && '100%'};
       // margin: 10px 15px;
        ${({ weekView }) =>
            weekView &&
            `margin: 5px 0;  width:148.87px; min-width:148.87px;
        max-width:148.87px; `}
    `}

    ${media.mobileDevice`
        max-width: ${({ mobileMaxWidth }) =>
            mobileMaxWidth ? mobileMaxWidth :  '100%'};
        min-width: unset;
        flex-basis: 100%;
         width: auto;
        justify-content:  ${({ justifyContent }) => justifyContent || 'space-evenly'};
        background: ${({ background, backgroundColor }) =>
            background || backgroundColor || '#ffffff 0% 0% no-repeat padding-box'};
        border: ${({ border }) =>
            typeof border === 'string'
                ? border
                : border && border.border
                ? border.border
                : 'none'};
          border-left: ${({ borderLeft }) => borderLeft ? 'none' :borderLeft };
        margin: ${({ mobileMargin, margin }) =>
            mobileMargin || margin || '10px 15px'};
        margin-bottom: ${({ mbMarginBottom }) => mbMarginBottom ? mbMarginBottom : '10px'};
    `}
`;